import { Modal, ModalProps } from 'antd'
import React from 'react'

type PropsModal = ModalProps

export const ModalFullscreen: React.FC<PropsModal> = props => {
  return (
    <Modal
      {...props}
      style={{
        top: 0,
        margin: 0,
        padding: 0,
        height: 'var(--100vh)',
        width: '100vw',
      }}
      styles={{
        content: {
          height: 'var(--100vh)',
          width: '100vw',
          overflowY: 'hidden',
          display: 'flex',
          flexDirection: 'column',
          padding: '0px',
          borderRadius: '0px',
        },
        body: {
          flex: 1,
          overflowY: 'auto',
          padding: '16px',
        },
        header: {
          padding: '8px 16px 0px 16px',
          margin: 0,
        },
        footer: {
          padding: '0px 16px 8px 16px',
          margin: 0,
        },
      }}
    />
  )
}
